<div class="image-cell">
  <!-- Display image when path is available -->
  <img
    *ngIf="safeImageUrl && !imageLoadError && !isLoadingImage"
    [src]="safeImageUrl"
    [alt]="altText"
    [ngStyle]="imageStyles"
    (load)="onImageLoad()"
    (error)="onImageError()"
    class="cell-image"
  />

  <!-- Loading indicator -->
  <div *ngIf="isLoadingImage" class="image-placeholder">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Loading image...</span>
  </div>

  <!-- Placeholder when no image or in edit mode -->
  <div *ngIf="!safeImageUrl && !isLoadingImage || imageLoadError" class="image-placeholder">
    <mat-icon>image</mat-icon>
    <span *ngIf="!imagePath">{{ isEditMode ? 'Configure image source' : 'No image selected' }}</span>
    <span *ngIf="imagePath && imageLoadError" class="error-text">Failed to load image</span>
  </div>
</div>
